import React from 'react';
import MedicalWaste from '../../../views/practice/wastemanagement/medicalwaste/MedicalWaste';
import PharmaceuticalWaste from '../../../views/practice/wastemanagement/pharmaceuticalwaste/PharmaceuticalWaste';
import AmalgamWaste from '../../../views/practice/wastemanagement/amalgamwaste/AmalgamWaste';

const wasteManagementRoutes = [
  {
    path: '/practice/medical-waste',
    element: <MedicalWaste />
  },
  {
    path: '/practice/pharmaceutical-waste',
    element: <PharmaceuticalWaste />
  },
  {
    path: '/practice/amalgam-waste',
    element: <AmalgamWaste />
  }
];

export default wasteManagementRoutes;
